export const RESERVATIONS_ON_DELETE_REQUESTED = 'RESERVATIONS_ON_DELETE_REQUESTED';
export const RESERVATIONS_ON_DELETE_SUCCEEDED = 'RESERVATIONS_ON_DELETE_SUCCEEDED';
export const RESERVATIONS_ON_DELETE_FAILED = 'RESERVATIONS_ON_DELETE_FAILED';

export const RESERVATIONS_ON_GET_ALL_REQUESTED = 'RESERVATIONS_ON_GET_ALL_REQUESTED';
export const RESERVATIONS_ON_GET_ALL_SUCCEEDED = 'RESERVATIONS_ON_GET_ALL_SUCCEEDED';
export const RESERVATIONS_ON_GET_ALL_FAILED = 'RESERVATIONS_ON_GET_ALL_FAILED';

export const RESERVATIONS_ON_GET_FORM_REQUESTED = 'RESERVATIONS_ON_GET_FORM_REQUESTED';
export const RESERVATIONS_ON_GET_FORM_SUCCEEDED = 'RESERVATIONS_ON_GET_FORM_SUCCEEDED';
export const RESERVATIONS_ON_GET_FORM_FAILED = 'RESERVATIONS_ON_GET_FORM_FAILED';

export const RESERVATIONS_ON_GET_ONE_REQUESTED = 'RESERVATIONS_ON_GET_ONE_REQUESTED';
export const RESERVATIONS_ON_GET_ONE_SUCCEEDED = 'RESERVATIONS_ON_GET_ONE_SUCCEEDED';
export const RESERVATIONS_ON_GET_ONE_FAILED = 'RESERVATIONS_ON_GET_ONE_FAILED';

export const RESERVATIONS_ON_SAVE_REQUESTED = 'RESERVATIONS_ON_SAVE_REQUESTED';
export const RESERVATIONS_ON_SAVE_SUCCEEDED = 'RESERVATIONS_ON_SAVE_SUCCEEDED';
export const RESERVATIONS_ON_SAVE_FAILED = 'RESERVATIONS_ON_SAVE_FAILED';
